import { hashHistory   } from 'react-router'; 
import * as types from '../constants/actionTypes';
import { resourceApi } from '../utils/fetchUtil';


export function receiveInsuranceCards(dasCards) {
    return {
      type: types.RECEIVE_INSURANCE_CARD,
      cards: dasCards
    }
  }
  
  export function receiveBenefits(dasBenefits) {
    return {
      type: types.RECEIVE_BENEFITS,
      benefits: dasBenefits
    }
  }

  export function receiveClientUserPlans(dasPlans) {
    return {
      type: types.RECEIVE_PLANS,
      plans: dasPlans
    }
  }
  
//   export function receiveIncentives(dasIncentives) {
//     return {
//       type: types.RECEIVE_INCENTIVES,
//       incentives : dasIncentives
//     }
//   }



export function loadClientUserPlans() {
  return function(dispatch) {
    let config = {
      method: 'get',
      url: `v2/member/plans`
    };
      return resourceApi(config)
      .then(response => response.data)
      .then(data => dispatch(receiveClientUserPlans(data)))
      .catch(err => console.log(err))
    }
  }

  export function loadInsuranceCard() {
    return (dispatch) => {

        let config = {
            method: 'get',
            url: `member/benefits/2`
        };

        return resourceApi(config)
        .then(function (response) {     
            //self.setState({ insuranceCards: response.data });
            dispatch(receiveInsuranceCards(response.data));
        })
        .catch(function (error) {
            console.log(error);
        });
    }
    //dispatch(loadInsuranceCard());
}

export function loadBenefits() {
   
    return (dispatch) => {

       let config = {
           method: 'get',
           url: `member/benefits/1`
       };

      resourceApi(config, dispatch) 
       .then(function (response) {
           dispatch(receiveBenefits(response.data));
           hashHistory.push("/account/benefits");
       })
       .catch(function (error) {
           console.log(error);
       });
   }
}


// export function loadIncentives() {
   
//     return (dispatch) => {

//        let config = {
//            method: 'get',
//            url: `member/benefits/3`
//        };

//       resourceApi(config, dispatch) 
//        .then(function (response) {
//            dispatch(receiveIncentives(response.data));
//            hashHistory.push("/account/incentives");
//        })
//        .catch(function (error) {
//            console.log(error);
//        });
//    }
// }


// WEBPACK FOOTER //
// ./src/actions/memberActions.js